<template>
  <div>
    <Teleport v-if="afetrTitleActionSpaceMounted" to="#page-title-action-space">
      <div class="d-flex justify-content-end">
        <BasicButton
          v-if="isABCTManager"
          label="編集"
          outlined
          icon="pi pi-pencil"
          @click="
            goto({ name: 'UsersSystemAdminTrainingsEdit', params: { id: id } })
          "
        />
      </div>
    </Teleport>
    <Card>
      <template #content>
        <TrainingShow v-if="training" :training="training" />
        <div class="d-flex flex-wrap justify-content-center my-5">
          <BasicButton
            label="戻る"
            class="me-5"
            outlined
            variant="secondary"
            icon="pi pi-times"
            @click="backto({ confirm: false })"
          />
        </div>
      </template>
    </Card>
  </div>
</template>

<script setup lang="ts">
import { inject } from "vue";
import { useRouterUtil, useTrainings, useUser } from "/@/vue/composables";
import { BasicButton } from "/@/vue/components/Atom";
import { Show as TrainingShow } from "/@/vue/components/Molecules/Trainings";
import Card from "primevue/card";

const afetrTitleActionSpaceMounted = inject("afetrTitleActionSpaceMounted");

const { id, backto, goto } = useRouterUtil();

const { isABCTManager } = useUser();

const { getTraining } = useTrainings();
const { data: training } = getTraining(id, {
  withWatchedUserNames: true,
  withAttachedUrl: true,
});
</script>

<style scoped></style>
